import React, { useState } from "react";
import { CardNumberElement } from "@stripe/react-stripe-js";
import {
  StripeCardNumberElementChangeEvent,
  StripeCardNumberElementOptions,
  StripeElementChangeEvent,
  StripeElements,
} from "@stripe/stripe-js";
import { AmexIcon } from "../icons/AmexIcon";
import { CreditCardIcon } from "../icons/CreditCardIcon";
import { MastercardIcon } from "../icons/MastercardIcon";
import { UnionPayIcon } from "../icons/UnionPayIcon";
import { VisaIcon } from "../icons/VisaIcon";
import { WarningIcon } from "../icons/WarningIcon";

const CardNumberInput = ({
  elements,
  stripeElementsOptions,
  tt,
  disableAutoFocus,
}: {
  elements: StripeElements;
  stripeElementsOptions: StripeCardNumberElementOptions;
  tt: {
    cardNumber: string;
  };
  disableAutoFocus?: boolean;
}) => {
  const [isCardNumberEmpty, setCardNumberEmpty] = useState<boolean>(true);
  const [brandIcon, setBrandIcon] = useState<StripeCardNumberElementChangeEvent["brand"]>("unknown");
  const [numberError, setNumberError] = useState<StripeElementChangeEvent["error"] | null>(null);

  return (
    <div className={`relative rounded-xl text-grey cursor-text select-none w-full`}>
      <CardNumberElement
        id="card-number-element"
        options={{
          ...stripeElementsOptions,
          placeholder: "",
          showIcon: false,
        }}
        onChange={(event: any) => {
          setNumberError(event.error);
          if (event.brand) {
            setBrandIcon(event.brand);
          }
          if (!event.empty) {
            setCardNumberEmpty(false);
          } else {
            setCardNumberEmpty(true);
          }
        }}
        onReady={() => {
          if (!disableAutoFocus) {
            elements?.getElement(CardNumberElement)?.focus();
          }
        }}
      />
      <label
        htmlFor="cardNumber"
        className={`absolute inset-y-0 py-3.5 px-5 text-lg duration-300 origin-0 w-96 cursor-text pointer-events-none select-none ${
          isCardNumberEmpty ? "" : "transform scale-70 -translate-y-3.5"
        }`}
      >
        {tt.cardNumber}
      </label>
      <div
        className="absolute right-3 pointer-events-none select-none"
        style={{ top: "1.125rem", bottom: "1.125rem" }}
      >
        <span className="flex flex-col h-full right-0">
          {brandIcon === "visa" ? (
            <VisaIcon className="h-5" />
          ) : brandIcon === "mastercard" ? (
            <MastercardIcon className="h-5" />
          ) : brandIcon === "amex" ? (
            <AmexIcon className="h-5" />
          ) : brandIcon === "unionpay" ? (
            <UnionPayIcon className="h-5" />
          ) : (
            <CreditCardIcon className="h-5" />
          )}
        </span>
      </div>
      {numberError && (
        <div className="flex flex-row items-center text-xs pt-0.5 text-red">
          <WarningIcon className="mr-1" />
          {numberError.message}
        </div>
      )}
    </div>
  );
};

export default React.memo(CardNumberInput);
